import React from 'react';
import styled from 'styled-components';
import { Main } from 'styles/themeColors';

const Container = styled.div`
  min-width: 17rem;
  z-index: 1000;
`;

const Description = styled.div`
  font-size: 0.8rem;
`;

const Heading = styled.div`
  color: ${Main.black};
  font-weight: bold;
`;

interface Props {
    className?: string;
    error: {
        description: string;
        name: string;
    };
}

const IssueSelectorOption = ({ className, error }: Props) => {
    return (
        <Container className={className}>
            <Heading>{error.name}</Heading>
            <Description>{error.description}</Description>
        </Container>
    );
}

export default IssueSelectorOption;
